enum PermissionNameEnum {
	geolocation = 'geolocation',
	notifications = 'notifications',
	push = 'push',
	midi = 'midi',
	camera = 'camera',
	microphone = 'microphone',
	backgroundFetch = 'background-fetch',
	backgroundSync = 'background-sync',
	persistentStorage = 'persistent-storage',
	ambientLightSensor = 'ambient-light-sensor',
	accelerometer = 'accelerometer',
	gyroscope = 'gyroscope',
	magnetometer = 'magnetometer',
	screenWakeLock = 'screen-wake-lock',
	nfc = 'nfc',
	displayCapture = 'display-capture',
	accessibilityEvents = 'accessibility-events',
	clipboardRead = 'clipboard-read',
	clipboardWrite = 'clipboard-write',
	paymentHandler = 'payment-handler',
	idleDetection = 'idle-detection',
	periodicBackgroundSync = 'periodic-background-sync',
	systemWakeLock = 'system-wake-lock',
	storageAccess = 'storage-access',
	windowManagement = 'window-management',
	windowPlacement = 'window-placement',
	localFonts = 'local-fonts',
	topLevelStorageAccess = 'top-level-storage-access'
}

export default PermissionNameEnum;
